import React from "react";
//connect can also be used with functional components if need be
import { connect } from 'react-redux';
import { setCurrentSlide } from '../../actions';

class NavThumbnails extends React.Component {

    constructor(props) {
        super(props);
        this.imageCount = 0;
    };

    //I also need the countdown to start over.
    onViewSelectedThumbnail = (selection) => {
        this.props.setCurrentSlide(selection);
        this.props.pauseSlideShow();
    };

    componentDidMount = () => {
        //wire up buttons references
        let nextNavigationThumbnails = document.getElementById('nextNavigationThumbnails');
        let previousNavigationThumbnails = document.getElementById('previousNavigationThumbnails');

        //since this.props.currentSlide always starts at -1, this ternary is needed
        nextNavigationThumbnails.onclick = () => {
            //alert("alert from NavThumb1 " + this.props.currentSlide)
            if (this.props.currentSlide + 7 < this.props.slideshowImages.length) {
                let startingPos = this.props.currentSlide === -1 ? this.props.currentSlide + 3 : this.props.currentSlide + 2;
                this.props.setCurrentSlide(startingPos);
            }
            this.onViewSelectedThumbnail(this.props.currentSlide);
            //alert("alert from NavThumb2 " + this.props.currentSlide)
        };

        //since this.props.currentSlide always starts at -1, this ternary is needed
        previousNavigationThumbnails.onclick = () => {
            if (this.props.currentSlide > 0) {

                let startingPos = this.props.currentSlide === -1 ? this.props.currentSlide - 3 : this.props.currentSlide - 2;
                startingPos = startingPos < 0 ? 0 : startingPos;
                this.props.setCurrentSlide(startingPos);
            }
            this.onViewSelectedThumbnail(this.props.currentSlide);
        };
    }


    renderList = () => {
        this.imageCount = 0;
        //DO NOT REMOVE THIS React.Fragment
        return <React.Fragment>{this.props.slideshowImages.map((image, index) => {
            if (index > this.props.currentSlide - 1) {
                this.imageCount++;
                if (this.imageCount > 7) {
                    return null;
                }
                else {
                    return (
                        <li key={image.index} className={`column imageDescription NavThumbnails`}>
                            <a href="#!">
                                <img onClick={() => this.onViewSelectedThumbnail(index)}
                                    src={`${image.imagepath}${image.index}a.jpg`}
                                    alt={`${image.description}`}
                                    className="portfolioImage" />
                            </a>
                            <div className="breakword portfolioOverlay">{`${image.description} (${image.index})`}</div>
                        </li>
                    );
                };
            } else {
                return null;
            }
        })}</React.Fragment>
    }

    render() {
        return (
            <div>
                {/* this style is what it took to get the navigation thumbnails centered without flex-wrap: wrap */}
                <div>
                    <ul className="no-bullets thumbnailNavigation">
                        <li style={{ width: '100%' }}><a href="#!"><h1 style={{ paddingTop: '20px', paddingRight: '1px', paddingBottom: '20px', paddingLeft: '1px' }} id="previousNavigationThumbnails">&#60;</h1></a></li>
                        {this.renderList()}
                        <li style={{ width: '100%' }}><a href="#!"><h1 style={{ paddingTop: '20px', paddingRight: '1px', paddingBottom: '20px', paddingLeft: '1px' }} id="nextNavigationThumbnails">&#62;</h1></a></li>
                    </ul>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        currentSlide: state.fetchCurrentSlideReducer.currentSlide,
        slideshowImages: state.slideshowImages,
        pauseSlideShow: state.fetchPauseSlideShowReducer.pauseSlideShow
    };
}
//NOTE action creators included here
export default connect(mapStateToProps, { setCurrentSlide: setCurrentSlide })(NavThumbnails);





